export default __webpack_public_path__ + "static/media/MECHA.f1b63140.png";